<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <center style="width: 100%"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="departmentLoader == true" /></center>

            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12 style="padding: 12px;">
                  <div class="screenTip">
            <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> This link is to test creating a service form either
              as a customer or a Builders rep for a specific store.
                    </span>
                  </div>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Store:</label>
                  <v-select :items="branchList" v-model="store" item-value="code" item-text="name" label="Store" autocomplete solo></v-select>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Customer Name and Surname:</label>
                  <v-text-field label="Customer Name and Surname" v-model="customerName" single-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Customer Email:</label>
                  <v-text-field label="Customer Email" v-model="customerEmail" single-line required solo></v-text-field>
                  <small class="smallDescription">Ensure the email address is in the Builders
                    Public user tree</small>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Customer Contact:</label>
                  <v-text-field label="Customer Contact" v-model="customerContact" single-line required solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Agent Email:</label>
                  <v-text-field label="Agent Email" v-model="agentEmail" single-line required solo></v-text-field>
                  <small class="smallDescription">Leave this blank if you are testing a customer form<br>Ensure the email address is in the Builders
                   Rep user tree</small>
                </v-flex>
                <v-flex style="padding:30px !important; text-align:center;background: #efefef;" lg12 v-if="generatedLink != ''">
                  <h3 style="font-size:12px !important;">{{ generatedLink }}</h3>
                </v-flex>
              </v-layout>
            </v-container>

        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-btn color="success" class="text-xs-right" @click.stop="fncGenerateLink()">Generate Link</v-btn>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Sortable from 'sortablejs';

  export default {
    name: 'RegionAdd',
    data () {
      return {
        search: '',
        store: '',
        customerName: '',
        customerEmail: '',
        customerContact: '',
        agentEmail: ''
      };
    },
    methods: {
      fncHideModal () {
        this.$store.commit('hideModal');
      },
      fncGenerateLink() {
        this.$store.dispatch({
          type: 'fncGenerateLink',
          store: this.store,
          customerName: this.customerName,
          customerEmail: this.customerEmail,
          customerContact: this.customerContact,
          agentEmail: this.agentEmail,
          token: this.globalModalParams.token,
          id: this.globalModalParams.id
        });
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'branchList',
        'generatedLink'
      ])
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateBranches');
    },
    watch: {
      runAdd() {
        if( this.runAdd === false ) {
          this.isAddValid = false;
          this.regionLink = '';
          this.regionName = '';
          this.regionDescription = '';
          this.regionType = '';
        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
